<div class="snippets-wrapper">
    <h3 *ngIf="!nestedHeading" class="fs-5 fs-md-3 text-maroon fw-bold" [innerHtml]="mainTitle"></h3>
    <h4 *ngIf="nestedHeading" class="fs-5 fs-md-3 text-maroon fw-bold" [innerHtml]="mainTitle"></h4>
    <p class="fs-6 fs-md-18" [innerHtml]="mainSummary"></p>

    <ul class="snippet-list">
        <li class="fs-6 fs-md-18 text-maroon" *ngIf="showPopulationEstimate && populationEstimateTitle && populationEstimateBody">
            <div class="li-wrap">
                <strong class="text-maroon pe-1" [innerHtml]="populationEstimateTitle"></strong>
                <span class="text-bluegray">{{ populationEstimateBody }}</span>
                <span class="text-bluegray ps-1 text-nowrap">
                    <span class="me-xl-2" [innerHtml]="populationEstimateBodyLastWord"> </span>
                    <app-tooltip [text]="populationEstimateTooltip" accessibleLabel="More information about population estimates" mobileIconClass="icon-small"></app-tooltip>
                </span>
            </div>
        </li>

        <li class="fs-6 fs-md-18 text-maroon" *ngIf="ageAtOnsetTitle && ageAtOnsetBody">
            <div class="li-wrap">
                <strong class="text-maroon pe-1" [innerHtml]="ageAtOnsetTitle"></strong>
                <span class="text-bluegray">{{ ageAtOnsetBody }}</span>
            </div>
        </li>

        <li class="fs-6 fs-md-18 text-maroon" *ngIf="causeArticleTitle && causeArticleBody">
            <div class="li-wrap">
                <strong class="text-maroon pe-1" [innerHtml]="causeArticleTitle"></strong>
                <span class="text-bluegray">{{ causeArticleBody }}</span>
            </div>
        </li>

        <li class="fs-6 fs-md-18 text-maroon" *ngIf="patientOrgTitle && patientOrgBody">
            <div class="li-wrap">
                <strong class="text-maroon pe-1" [innerHtml]="patientOrgTitle"></strong>
                <span class="text-bluegray">{{ patientOrgBody }}</span>
            </div>
        </li>

        <li class="fs-6 fs-md-18 text-maroon" *ngIf="newbornTitle && newbornBody">
            <div class="li-wrap">
                <strong class="text-maroon pe-1" [innerHtml]="newbornTitle"></strong>
                <span class="text-bluegray">{{ newbornBody }}</span>
                <span class="text-bluegray ps-1 text-nowrap">
                    <span class="me-xl-2" [innerHtml]="newbornBodyLastWord"> </span>
                    <app-tooltip [text]="newbornTooltip" accessibleLabel="More information about newborn screening" mobileIconClass="icon-small"></app-tooltip>
                </span>
            </div>
        </li>

        <li class="snippet-categories fs-6 fs-md-18 text-maroon" *ngIf="categories.length">
            <div class="li-wrap">
                <strong class="text-maroon pe-1" [innerHtml]="categoriesTitle"></strong>
                <span *ngFor="let category of categories" class="text-bluegray d-print-block">
                    <span>{{ category.nameCuratedAllButLast | titleCaseWord }}</span>
                    <span class="text-bluegray text-nowrap">
                        <span>&nbsp;</span><span [innerHtml]="category.nameCuratedLast"></span>
                        <app-tooltip
                            [text]="category.textSnippet"
                            [accessibleLabel]="'More information about ' + (category.nameCurated || category.name)"
                            mobileIconClass="icon-small"
                        ></app-tooltip>
                    </span>
                </span>
            </div>
        </li>
    </ul>
</div>
